import { pushAnalyticsEvent } from "@ottatech/analytics";
import { useEffect, useMemo } from "react";
import { Navigate, useParams, useSearchParams } from "react-router-dom";

export function ReferralRedirect(): React.ReactElement {
  const { referrerId } = useParams<"referrerId">();

  const [searchParams] = useSearchParams();

  const qs = useMemo(() => {
    const newSearchParams = new URLSearchParams(searchParams);

    if (referrerId) {
      newSearchParams.set("referrer", referrerId);
    }

    return newSearchParams;
  }, [referrerId, searchParams]);

  useEffect(() => {
    pushAnalyticsEvent({
      eventName: "Candidate used referral link",
      referrerId,
    });
  }, [referrerId]);

  return (
    <Navigate to={{ pathname: "/sign-up", search: qs.toString() }} replace />
  );
}
